import { render, staticRenderFns } from "./payChannel.vue?vue&type=template&id=9cbfce48&scoped=true"
import script from "./payChannel.vue?vue&type=script&lang=js"
export * from "./payChannel.vue?vue&type=script&lang=js"
import style0 from "./payChannel.vue?vue&type=style&index=0&id=9cbfce48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbfce48",
  null
  
)

export default component.exports